import * as React from "react"
import './src/styles/global.css'
import type { GatsbyBrowser } from "gatsby"

export const wrapPageElement: GatsbyBrowser["wrapPageElement"] = ({element}) => {

    return (
        <>
            {element}
        </>
    )

}